// extracted by mini-css-extract-plugin
module.exports = {"ellipseContainer":"OrganicAbout_ellipseContainer__kpZMB","ellipse":"OrganicAbout_ellipse__rlelT"};